"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordResetConfirmPage = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const component_1 = require("@front/components/form-parts/form/component");
const component_2 = require("@front/components/site-menu/component");
const PopupService_1 = __importStar(require("@front/services/PopupService"));
//@ts-ignore                
let rwsTemplate = T.html `<div class="fixed-background"
    style="background: url(/assets/images/laptop-5673901_1280.jpg) no-repeat 50% fixed; background-size: cover;">
</div>
<main>
    <div id="firstpages-lang">
        <lang-switcher></lang-switcher>
    </div>
    <div class="container">
        <div class="h-100 row">
            <div class="mx-auto my-auto col-12 col-md-10">
                <div class="auth-card card">
                    <div class="position-relative image-side "
                        style="background:url(/assets/images/keyboard-5017973_1280.jpg); background-size: cover;">
                        <p class="text-white h2">${'password.reset.confirm.hero.title'.t()}</p>
                        <p class="white mb-0">
                            ${'password.reset.confirm.hero.description'.t()}
                            <br>${'password.reset.confirm.hero.login_link_text'.t()}
                            <a href="/">${'password.reset.confirm.hero.login_link'.t()}</a>.
                        </p>
                    </div>
                    <div class="form-side">
                        <a aria-current="page" class="active h4 mb-4 d-block" href="/">
                            ${'password.reset.confirm.page.title'.t()}
                        </a>
                        ${(0, fast_element_1.when)(x => !x.success, (0, fast_element_1.html) `
                            <div class="mb-4 card-title">${'password.reset.confirm.form.title'.t()}</div>
                            <the-form :onSubmit="${(x, c) => x.sendForm.bind(x)}">
                                <part-input 
                                    required="true" 
                                    name="password" 
                                    type="password"
                                    label="${'password.reset.confirm.password.label'.t()}"
                                    placeholder="${'password.reset.confirm.password.placeholder'.t()}"
                                    :value="${x => x.form.password}"
                                ></part-input>
                                <part-input 
                                    required="true" 
                                    name="confirmPassword" 
                                    type="password"
                                    label="${'password.reset.confirm.confirmPassword.label'.t()}"
                                    placeholder="${'password.reset.confirm.confirmPassword.placeholder'.t()}"
                                    :value="${x => x.form.confirmPassword}"
                                ></part-input>
                                
                                <div class="d-flex justify-content-between align-items-center">
                                    <a href="/">${'password.reset.backToLogin'.t()}</a>
                                    <button @click="${(x, c) => x.sendSubmit(x, c)}" class="btn-shadow btn-multiple-state btn btn-primary btn-lg" :disabled="${x => x.loading}">
                                        ${(0, fast_element_1.when)(x => x.loading, (0, fast_element_1.html) `
                                            <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                        `)}
                                        <span class="label">${'password.reset.confirm.submit'.t()}</span>
                                    </button>
                                </div>
                            </the-form>
                        `)}
                        
                        ${(0, fast_element_1.when)(x => x.success, (0, fast_element_1.html) `
                            <div class="text-center">
                                <div class="mb-4">
                                    <i class="icon-check2 text-success" style="font-size: 3rem;"></i>
                                </div>
                                <div class="mb-4 card-title">${'password.reset.confirm.success.title'.t()}</div>
                                <p class="text-muted mb-4">${'password.reset.confirm.success.description'.t()}</p>
                                <a href="/" class="btn btn-primary btn-lg">
                                    ${'password.reset.backToLogin'.t()}
                                </a>
                            </div>
                        `)}
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>`;
require("./styles/layout.scss");
const styles = T.css `:host {
  height: 100%;
  display: block;
}

#firstpages-lang {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1000;
  padding: 10px;
  background-color: rgba(255, 255, 255, 0.4);
  border-radius: 5px;
}

main {
  margin: 0 !important;
  height: 100%;
}
main .container {
  height: 100%;
}
main a {
  color: var(--primary-color);
}
main .icon-check2 {
  color: #28a745 !important;
}`;
const shadowOptions = { "mode": "open" };
let PasswordResetConfirmPage = class PasswordResetConfirmPage extends client_1.RWSViewComponent {
    constructor(popupService) {
        super();
        this.popupService = popupService;
        this.loading = false;
        this.success = false;
        this.token = '';
        this.form = {
            password: '',
            confirmPassword: ''
        };
        this.sendSubmit = component_1.FormComponent.sendSubmitEvent;
    }
    async connectedCallback() {
        super.connectedCallback();
        component_1.FormComponent.listenForValuesChange.bind(this)('form');
        this.togglePreloader();
    }
    getBody() {
        return document.querySelector('body');
    }
    getPreloader() {
        return document.querySelector('#preloader');
    }
    togglePreloader() {
        const preloader = this.getPreloader();
        if (preloader.classList.contains('hidden')) {
            preloader.classList.remove('hidden');
        }
        else {
            preloader.classList.add('hidden');
        }
    }
    async sendForm(event) {
        event.preventDefault();
        try {
            this.loading = true;
            if (this.form.password !== this.form.confirmPassword) {
                this.popupService.alert('password.reset.confirm.mismatch'.t());
                return;
            }
            if (this.form.password.length < 6) {
                this.popupService.alert('password.reset.confirm.length'.t());
                return;
            }
            const response = await this.apiService.back.post('user.password.reset.confirm', {
                token: this.token,
                password: this.form.password,
                confirmPassword: this.form.confirmPassword
            });
            if (!response.success) {
                this.popupService.alert(response.error);
            }
            else {
                this.success = true;
            }
        }
        catch (e) {
            console.error(e);
        }
        finally {
            this.loading = false;
        }
    }
    goToLogin() {
        component_2.SiteMenu.goto.bind(this)('/login');
    }
};
exports.PasswordResetConfirmPage = PasswordResetConfirmPage;
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], PasswordResetConfirmPage.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], PasswordResetConfirmPage.prototype, "success", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], PasswordResetConfirmPage.prototype, "token", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], PasswordResetConfirmPage.prototype, "form", void 0);
exports.PasswordResetConfirmPage = PasswordResetConfirmPage = __decorate([
    (0, client_1.RWSView)('password-reset-confirm-page', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(PopupService_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof PopupService_1.PopupServiceInstance !== "undefined" && PopupService_1.PopupServiceInstance) === "function" ? _a : Object])
], PasswordResetConfirmPage);
PasswordResetConfirmPage.defineComponent();
